import type { Dispatch } from 'redux';
import StaticMap from 'app/shared/modules/map/StaticMap';
import getGmapTheme from 'app/client/utils/map/gmapTheme';
import DISPATCH_CONSTANTS from 'app/shared/constants/DispatchConstants';
import routeUtils from 'app/shared/utils/routeUtils';

type PlaceholderMap = Record<string, string>;

const PLACEHOLDER_MAP: PlaceholderMap = {
  3: '',
  4: '',
  5: '',
  6: '',
  7: '',
  8: '',
  9: '',
  10: '',
  11: '',
  12: '',
  13: '',
  14: '',
  15: '',
  16: '',
  17: '',
  18: '',
};

type AreaCoordinates = {
  coordinates?: {
    lat?: number | string;
    lon?: number | string;
  };
  [key: string]: unknown;
};

type QueryParams = Record<string, string | number | boolean | undefined>;

const _getLatLon = ({ area, query }: { area: AreaCoordinates; query: QueryParams }) => {
  const hasLatAndLonInQuery = routeUtils.hasLatAndLon(query);
  if (hasLatAndLonInQuery) {
    return {
      lat: Number(query.lat),
      lon: Number(query.lon),
    };
  } else {
    return {
      lat: Number(area.coordinates?.lat || 0),
      lon: Number(area.coordinates?.lon || 0),
    };
  }
};

export const MapActions_fetchStaticMap = ({ area, query }: { area: AreaCoordinates; query: QueryParams }) => {
  return async (dispatch: Dispatch) => {
    const latLonDataSansZoom = _getLatLon({ area, query });
    const zoomLevels = Object.keys(PLACEHOLDER_MAP);
    const staticMapPromises = zoomLevels.map((zoom) => {
      // @ts-expect-error StaticMap module has @ts-nocheck
      const staticMap = new StaticMap({});
      const defaultHeight = 720;
      const defaultWidth = 962;

      staticMap
        .centerByLatAndLon(latLonDataSansZoom.lat, latLonDataSansZoom.lon)
        .size(defaultWidth, defaultHeight)
        .zoom(zoom)
        .styleFromConfig(getGmapTheme())
        .style({
          feature: 'all',
          element: 'labels',
          visibility: 'off',
        });

      return dispatch(staticMap.generate()).then((res: { data: { signedUrl: string } }) => {
        const { data } = res;
        const { signedUrl } = data;

        return (PLACEHOLDER_MAP[zoom] = signedUrl);
      });
    });

    await Promise.all(staticMapPromises).then(() => {
      // Promises have resolved
      // @ts-expect-error Redux thunk dispatch with nested thunk returns not fully typed
      return dispatch(MapActions_saveStaticMap(PLACEHOLDER_MAP));
    });
  };
};

export const MapActions_saveStaticMap = (placeholders: PlaceholderMap) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: DISPATCH_CONSTANTS.SAVE_STATIC_MAP_PLACEHOLDERS,
      payload: placeholders,
    });
  };
};
